View = require 'view'
templates = require 'views/internal/templates'

module.exports = class OrganizationListItemView extends View
  tagName: 'li'

  render: ->
    data = @model.toJSON(prefs: true, url: true)
    data.visIconClass = @model.getPermLevel()
    data.hasBusinessClass = @model.isPremium()

    @$el.html(
      templates.fill(
        'organization_list_item',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-list-item-view.coffee